import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { canRenderAction } from "../../utils/common";
import { ACTION_FLAGS } from "../../constants/action_flags";
import { COMPONENTS } from "../../constants/component";
import { useNavigate } from "react-router-dom";
import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import ActionButtons from "../Selectors/ActionButtons";
import { TableFilter } from "./TableFilter";
import { deleteStructure } from "../../network/DataManagementApi";
import { TableHeader } from "./TableHeader";
import { TableBody } from "./TableBody";
import { TablePagination } from "./TablePagination";
import DeleteModal from "../Selectors/DeleteModal";

const StorageSystemList = () => {
  const [storageSystemToDelete, setStorageSystemToDelete] = useState(undefined);
  const [isDeleting, setIsDeleting] = useState(false);
  const [canDelete] = useState(
    canRenderAction(ACTION_FLAGS.CANDELETE, COMPONENTS.INSTANCE_DISPLAY)
  );
  const [canEdit] = useState(
    canRenderAction(ACTION_FLAGS.CANEDIT, COMPONENTS.INSTANCE_DISPLAY)
  );

  const [globalFilter, setGlobalFilter] = useState("");
  const storageSystemList = useSelector((state) => state.data.storage_system);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const history = useNavigate();
  useEffect(() => {
    const newData = Object.entries(storageSystemList);
    setData(newData);
  }, [storageSystemList]);
  const columnHelper = createColumnHelper();
  const columns = [
    columnHelper.accessor((row) => row[1].name, {
      id: "name",
      header: "Nom",
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor((row) => row[1].description, {
      id: "desc",
      header: "Description",
      cell: (info) => (
        <p className={"w-full whitespace-normal"}>{info.getValue()}</p>
      ),
    }),
    columnHelper.accessor((row) => row[1].storage_type, {
      id: "storage_type",
      header: "Type de stockage",
      cell: (info) => info.getValue(),
    }),
    columnHelper.display({
      id: "actions",
      header: "Actions",
      cell: (info) => (
        <ActionButtons
          handleEdit={() => {
            const row = info.row.original;
            history("/storage_system/edit/" + row[0]);
          }}
          handleDelete={() => {
            const row = info.row.original;
            setStorageSystemToDelete(row);
          }}
          canEdit={canEdit}
          canDelete={canDelete}
        />
      ),
    }),
  ];
  const table = useReactTable({
    data,
    columns,
    state: {
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });
  return (
    <div className="block bg-white rounded-lg border box-shadow-custom-4-sides border-gray-200 m-4">
      <div className="flex flex-col lg:flex-row justify-between mt-2">
        <div className="flex flex-row align-center px-3">
          <TableFilter
            value={globalFilter ?? ""}
            onChange={(value) => setGlobalFilter(String(value))}
          />
        </div>
      </div>
      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="py-2 align-middle inline-block min-w-full">
            <div className="shadow overflow-hidden border-b border-gray-200">
              <table className="min-w-full divide-y divide-gray-200">
                <TableHeader table={table} />
                <TableBody table={table} />
              </table>
            </div>
          </div>
        </div>
      </div>
      <TablePagination table={table} />
      {storageSystemToDelete && (
        <DeleteModal
          callback={() => {
            setIsDeleting(true);
            deleteStructure(storageSystemToDelete[0], () => {
              setIsDeleting(false);
              setStorageSystemToDelete(undefined);
            });
          }}
          loading={isDeleting}
          text={
            "Êtes vous sûr de vouloir supprimer la structure " +
            storageSystemToDelete[1].name +
            " ?"
          }
          modalVisible={storageSystemToDelete}
          setModalVisible={setStorageSystemToDelete}
        />
      )}
    </div>
  );
};
export default StorageSystemList;
